import React, { useState, useEffect, useRef } from "react";
import {
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Popover,
} from "react-bootstrap";
import PriestApi from "../../api/priestApi";
import { toast } from "react-toastify";
import CustomDataTable from "../../components/CustomDataTable";
import Helpers from "../../components/Helpers";
import DeleteModel from "../../components/DeleteModel";
import { Cookies, useCookies } from "react-cookie";
import { utils, writeFile } from "xlsx";
import AlertModal from "../../components/AlertModel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Profile from "../../assets/images/priest-default.png";
import corruptedImg from "../../assets/images/corrupted-img.png";
import AuthApi from "../../api/authApi";
import CopyIcon from "../../components/CopyIcon";
import CopyEmailsButton from "../../components/CopyEmailsButton";
import UpdatePriestPopUp from "./UpdatePriestPopUp";
import { useLocation } from "react-router-dom";
import { debounce } from "lodash";
import "../../assets/css/ManageCouplesModern.css";

const XLSX = require("xlsx");

const PriestList = () => {
  const locationData = useLocation();
  const [validated, setValidated] = useState(false);
  const [showRegModal, setShowREgModal] = useState(false);
  const [isTempUpload, setIsTempUpload] = useState(false);
  const [data, setData] = useState({
    id: "",
    parishId: null,
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    city: "",
    state: "",
    zip: "",
    imageUrl: "",
    address: "",
  });
  const [allPriestData, setAllPriestData] = useState([]);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [total, setTotal] = useState(20);
  const [searchKey, setSearchKey] = useState("");
  const [show, setShow] = useState(false);
  const [icon_id, setIcon_id] = useState("");
  let authApi = new AuthApi();
  let priestApi = new PriestApi();
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  const [cookie, setCookie] = useCookies(["LoveStrongUser"]);
  const [LoadData, setLoadData] = useState(false);
  const [roastersOfPriestList, setRoastersOfPriestList] = useState([]);
  const [isEditAdmin, setIsEditAdmin] = useState(false);
  const [parishList, setParishList] = useState([]);
  const [roasterCount, setRoasterCount] = useState("");
  const [oldValues, setOldValues] = useState([]);
  const [alreadyPk, setAlreadyPk] = useState();
  const openedAddFromQuery = useRef(false);

  useEffect(() => {
    setSearchKey("");
    getAllPriestData(1, 20, null, {});
    getParishList();

  }, []);

  const checkPKPriest = async () => {
    await priestApi
      .checkPKPriest()
      .then((res) => {
        if (res.success) {
          if (res.data != null) {
            setAlreadyPk(res.data);
            let d = { ...data };
            d.primaryKey = res.data;
            setData(d);
          } else {
            let defaultPK = "P101";
            setAlreadyPk(defaultPK);
            let d = { ...data };
            d.primaryKey = defaultPK;
            setData(d);
          }
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getParishList = async () => {
    setLoadData(true);
    await authApi
      .getPerishList()
      .then((response) => {
        const sortedList = response.data.sort((a, b) =>
          a.parish.localeCompare(b.parish),
        );
        setParishList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const clearfield = () => {
    setData({
      id: "",
      parishId: null,
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      city: "",
      state: "",
      zip: "",
      imageUrl: "",
      address: "",
    });
    setValidated(false);
  };

  useEffect(() => {
    if (openedAddFromQuery.current) return;
    const params = new URLSearchParams(locationData.search);
    if (params.get("add") !== "1") return;
    openedAddFromQuery.current = true;
    setShowREgModal(true);
    checkPKPriest();
    clearfield();
    params.delete("add");
    const next = params.toString();
    window.history.replaceState(
      {},
      "",
      `${locationData.pathname}${next ? `?${next}` : ""}${locationData.hash || ""}`,
    );
  }, [locationData.search, locationData.pathname, locationData.hash]);

  const getAllPriestData = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
  ) => {
    setLoadData(true);
    let d = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    } else if (searchKey) {
      d.searchKeyword = searchKey;
    }
    if (sortBy?.sortColumn) {
      d.sortBy = sortBy;
    }
    d.export = false;
    await priestApi
      .getAllPriests(d)
      .then((res) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setTotal(totalRecords);
          setAllPriestData(res.data);
          setLoadData(false);
        } else {
          setLoadData(false);
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        setLoadData(false);
        toast.error(error);
      });
  };

  const getroastersOfPriest = async (id) => {
    await priestApi
      .participatedInRetreats({ priest_Id: id })
      .then(async (response) => {
        setRoastersOfPriestList(response.data);
        setRoasterCount(response.totalRecords);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const editPriest = async (id) => {
    setIsTempUpload(false);
    setEdiUserIdClicked(id);
    let d = { ...data };
    try {
      const res = await priestApi.getPriestDetail({ priestId: id });
      if (!res.success) {
        toast.error(res.msg);
        return;
      }
      const priest = res.data;
      if (
        priest.email === "tkolkebeck@me.com" ||
        priest.email === "tkolkebeck@satx.rr.com" ||
        priest.email === "jimmieflores@gmail.com" ||
        priest.email === "dulceaflores@gmail.com"
      ) {
        setIsEditAdmin(true);
      }
      d.id = priest.id;
      d.primaryKey = priest.primaryKey;
      d.title = priest.title;
      d.firstName = priest.firstName;
      d.lastName = priest.lastName;
      d.email = priest.email;
      d.city = priest.city;
      d.state = priest.state;
      d.zip = priest.zip;
      d.parishId = priest.parishId;
      d.imageUrl = priest.imageUrl;
      d.address = priest.address;
      setData(d);
      setOldValues(priest);

    } catch (error) {
      console.error(error);
      toast.error("Failed to load priest details");
    }
  };

  const deletePriest = async () => {
    await priestApi
      .deletePriest({ priest_id: icon_id.id })
      .then(async (res) => {
        if (res.success) {
          getAllPriestData();
          setShow(false);
          setIcon_id("");
          checkPKPriest();
          toast.success(res.msg);

        } else {
          checkPKPriest();
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const popover = (row) => {
    return (
      <Popover id="popover-ImgPk" bsPrefix="popover">
        <Popover.Body>
          <div style={{ textAlign: "center", padding: "10px 0px" }}>
            {row.imageUrl ? (
              <span>
                <img
                  src={row.imageUrl}
                  className="column-rowImagePopover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = corruptedImg;
                  }}
                />
              </span>
            ) : (
              <img src={Profile} className="column-rowImagePopover" />
            )}
            <h6 className="couplename">
              {" "}
              {row &&
                `${row.title ? `${row.title} ` : ""}${row.firstName} ${row.lastName}`}
            </h6>
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const columns = [
    {
      id: "action",
      name: "Action",
      button: true,
      cell: (row) => (
        <>
          {userData && userData.userRole === "ADMIN" && (
            <>
              <button
                className="font-size"
                onClick={() => {
                  editPriest(row.id);
                  setShowREgModal(true);
                  getroastersOfPriest(row.id);
                }}
              >
                <i
                  className="mdi mdi-pencil-box text-lg text-primary font-size"
                  title="Edit"
                />
              </button>
              <button className="font-size" onClick={() => handleShow(row)}>
                <i
                  className="mdi mdi-delete-forever text-md text-danger mx-2 font-size"
                  title="Delete"
                />
              </button>
            </>
          )}
          <CopyEmailsButton emails={[row.email]} />
        </>
      ),
      reorder: true,
      width: userData && userData.userRole === "ADMIN" ? "140px" : "70px",
    },
    {
      id: "primaryKey",
      name: "Priest Id",
      selector: (row) => row.primaryKey,
      cell: (row) => (
        <OverlayTrigger placement="right" overlay={popover(row)}>
          {row.imageUrl ? (
            <span
              onClick={() => {
                editPriest(row.id);
                setShowREgModal(true);
                getroastersOfPriest(row.id);
              }}
            >
              <span className="roasterKey">
                {" "}
                <img
                  src={row.imageUrl}
                  className="column-rowImage"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = corruptedImg;
                  }}
                />
              </span>
              {row.primaryKey ? <span className="pk-id">{row.primaryKey}</span> : null}
            </span>
          ) : (
            <span
              onClick={() => {
                editPriest(row.id);
                setShowREgModal(true);
                getroastersOfPriest(row.id);
              }}
            >
              <span className="roasterKey">
                {" "}
                <img src={Profile} className="column-rowImage-profile" />
              </span>

              {row.primaryKey ? <span className="pk-id">{row.primaryKey}</span> : null}
            </span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
    },
    {
      id: "Title",
      name: "Title",
      selector: (row) => row.title,
      cell: (row) => (
        <OverlayTrigger
          overlay={renderTooltip(`${row.title || ""}`)}
        >
          <span
            onClick={() => {
              editPriest(row.id);
              setShowREgModal(true);
              getroastersOfPriest(row.id);
            }}
          >
            {row.title ? `${row.title} ` : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "firstName",
      name: "First Name",
      selector: (row) => row.firstName,
      cell: (row) => (
        <OverlayTrigger
          overlay={renderTooltip(`${row.firstName}`)}
        >
          <span
            onClick={() => {
              editPriest(row.id);
              setShowREgModal(true);
              getroastersOfPriest(row.id);
            }}
          >
            {/* {row.title ? `${row.title} ` : ""} */}
            {row.firstName?.slice(0, 10)}
            {(row.firstName?.length || 0) > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "lastName",
      name: "Last Name",
      selector: (row) => row.lastName,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.lastName)}>
          <span
            onClick={() => {
              editPriest(row.id);
              setShowREgModal(true);
              getroastersOfPriest(row.id);
            }}
          >
            {row.lastName?.slice(0, 10)}
            {row.lastName?.length > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "email",
      name: "Email",
      selector: (row) => row.email,
      cell: (row) => (
        <div className="d-flex align-items-center gap-1 w-100">
          <CopyIcon text={row.email} />
          <OverlayTrigger overlay={renderTooltip(row.email)}>
            <span>
              {row.email?.slice(0, 12)}
              {row.email?.length > 12 ? "..." : ""}
            </span>
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      reorder: true,
      style: { cursor: "text" },
      width: "150px",
    },
    {
      id: "Address",
      name: "Address",
      selector: (row) => row.address,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.address)}>
          <span>
            {row.address?.slice(0, 10)}
            {row.address?.length > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: { cursor: "text" },
      width: "150px",
    },
    {
      id: "Parish",
      name: "Parish",
      selector: (row) => row.parish,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.parish)}>
          <span>{row.parish}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
      style: { cursor: "text" },
    },
    {
      id: "city",
      name: "City",
      selector: (row) => row.city,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.city)}>
          <span>
            {row.city?.slice(0, 10)}
            {row.city?.length > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "state",
      name: "State",
      selector: (row) => row.state,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.state)}>
          <span>
            {row.state?.slice(0, 10)}
            {row.state?.length > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "zip",
      name: "Zip",
      selector: (row) => row.zip,
      sortable: true,
      reorder: true,
    },
    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
      cell: (row) => (
        <OverlayTrigger
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "DD-MM-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
    },
  ];

  const handleShow = (item) => {
    setShow(true);
    setIcon_id(item);
  };

  const handleClose = () => {
    setShow(false);
  };

  const CloseCompose = () => {
    setIsEditAdmin(false);
    setValidated(false);
    setShowREgModal(false);
    setEdiUserIdClicked("");
    clearfield();
  };

  // Debounced search function
  const debouncedSearch = React.useMemo(
    () =>
      debounce((value) => {
        getAllPriestData(1, 20, value, {});
      }, 500),
    [], // Empty dependency array ensures debounce is created only once
  );

  const SearchData = (event) => {
    const value = event.target.value;
    setSearchKey(value);
    debouncedSearch(value);
  };

  const handleExport = async () => {
    try {
      let d = {
        pageNo: 1,
        size: 20,
        export: true,
      };

      const res = await priestApi.getAllPriests(d);

      if (!res.success) {
        return toast.error(res.msg);
      }

      const exportData = res.data.map((element) => ({
        primaryKey: element.primaryKey || "",
        title: element.title || "",
        firstName: element.firstName || "",
        lastName: element.lastName || "",
        email: element.email || "",
        mobile: element.mobile || "",
        address: element.address || "",
        city: element.city || "",
        state: element.state || "",
        zip: element.zip || "",
        parish: element.parish || "",
      }));

      const headings = [
        [
          "Priest Id",
          "Title",
          "First Name",
          "Last Name",
          "Email",
          "Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Parish",
        ],
      ];

      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);

      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, {
        origin: "A2",
        skipHeader: true,
      });

      utils.book_append_sheet(wb, ws, "Data");
      writeFile(wb, "Priest_Data.xlsx");


    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const exportPdf = async () => {
    try {
      const doc = new jsPDF("landscape", "pt", "A1");
      const marginLeft = 40;

      doc.setFontSize(15);
      doc.text("All Priests", marginLeft, 40);

      const headers = [
        [
          "Priest Id",
          "Title",
          "First Name",
          "Last Name",
          "Email",
          "Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Parish",
        ],
      ];

      const res = await priestApi.getAllPriests({
        pageNo: 1,
        size: 20,
        export: true,
      });

      if (!res.success) {
        return toast.error(res.msg);
      }

      const data = res.data.map((element) => [
        element.primaryKey || "",
        element.title || "",
        element.firstName || "",
        element.lastName || "",
        element.email || "",
        element.mobile || "",
        element.address || "",
        element.city || "",
        element.state || "",
        element.zip || "",
        element.parish || "",
      ]);

      doc.autoTable({
        head: headers,
        body: data,
        startY: 70,
        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 3,
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
        },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 50 },
          2: { cellWidth: 80 },
          3: { cellWidth: 80 },
          4: { cellWidth: 150 },
          5: { cellWidth: 80 },
          6: { cellWidth: 150 },
          7: { cellWidth: 80 },
          8: { cellWidth: 60 },
          9: { cellWidth: 60 },
          10: { cellWidth: 120 },
        },
        margin: { left: marginLeft, right: 40 },
      });

      doc.save("Priest_Report.pdf");


    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const isAdmin = userData && userData.userRole === "ADMIN";

  return (
    <div className="mc-page">
      <header className="mc-header">
        <div>
          <p className="mc-kicker">Priest management</p>
          <div className="mc-title-row">
            <h1 className="mc-title">Spiritual Directors</h1>
            <span className="mc-count">{total || 0}</span>
          </div>
        </div>
        <div className="mc-header-actions">
          <a className="mc-btn mc-btn-ghost" href="/manageCouples">
            View all Couples
          </a>
          <button
            type="button"
            className="mc-btn mc-btn-primary"
            onClick={() => {
              setShowREgModal(true);
              checkPKPriest();
              clearfield();
            }}
          >
            <i className="mdi mdi-plus" />
            Add Spiritual Director
          </button>
        </div>
      </header>

      <div className="mc-toolbar">
        <label className="mc-field mc-field-search">
          <i className="mdi mdi-magnify" aria-hidden="true" />
          <input
            onChange={SearchData}
            type="search"
            placeholder="Search Spiritual Directors"
            aria-label="Search Spiritual Directors"
            value={searchKey}
          />
        </label>
        {isAdmin ? (
          <div className="mc-toolbar-meta">
            <Dropdown className="dropset">
              <Dropdown.Toggle
                className="btn btn-outline-secondary btn-sm"
                id="dropdown-basic"
              >
                <i className="mdi mdi-download" aria-hidden="true" />
                <span>Export</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleExport}>Excel</Dropdown.Item>
                <Dropdown.Item onClick={exportPdf}>PDF</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        ) : null}
      </div>

      <section className="mc-table-card" aria-label="Spiritual director list">
        <CustomDataTable
          loading={LoadData}
          data={allPriestData}
          columns={columns}
          total={total}
          countPerPage={20}
          isServerSide={true}
          pagination={true}
          sortServer={true}
          dataFetchApi={getAllPriestData}
          pointerOnHover={true}
          highlightOnHover={true}
          forCouple={true}
          noDataComponent={
            <div className="mc-empty">
              <p>No spiritual directors to show</p>
              <span>Try another search.</span>
            </div>
          }
        />
      </section>
        {show ? (
          <DeleteModel
            show={show}
            content={
              <>
                <h5 className="mt-4 fw-bold">
                  Spiritual Director (Priest) Detail
                </h5>

                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  {/* Priest Name */}
                  {(icon_id.firstName || icon_id.lastName) && (
                    <div className="mb-2">
                      <span className="fw-bold">Name:</span> {icon_id.firstName}{" "}
                      {icon_id.lastName}
                    </div>
                  )}

                  {/* Email */}
                  {icon_id.email && (
                    <div className="mb-2">
                      <span className="fw-bold">Email:</span>{" "}
                      <span className="text-muted">{icon_id.email}</span>
                    </div>
                  )}

                  {/* Parish */}
                  {icon_id.parish && (
                    <div className="mb-2">
                      <span className="fw-bold">Parish:</span>{" "}
                      <span className="text-muted">{icon_id.parish}</span>
                    </div>
                  )}

                  {/* Phone (optional) */}
                  {icon_id.phone && (
                    <div>
                      <span className="fw-bold">Phone:</span>{" "}
                      <span className="text-muted">{icon_id.phone}</span>
                    </div>
                  )}
                </div>
              </>
            }
            handleClose={handleClose}
            DeleteData={deletePriest}
          />
        ) : null}

        {showRegModal ? (
          <UpdatePriestPopUp
            showRegModal={showRegModal}
            setShowREgModal={setShowREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKPriest();
              setEdiUserIdClicked("");
              CloseCompose();
              getAllPriestData();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfPriestList={roastersOfPriestList}
            getAllPriests={getAllPriestData}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            setIsTempUpload={setIsTempUpload}
          />
        ) : null}
    </div>
  );
};

export default PriestList;
